import { Injectable } from "@angular/core";
import { AuthenticationService } from "../login/authentication/authentication.service";
import { Observable, of, Subject, forkJoin } from "rxjs";
import {
    ServicioModel,
    VtcHorasModel,
} from "src/app/shared/models/servicios/servicios.model";
import { HttpClient } from "@angular/common/http";
import {
    formatUrlRegulares,
    formatUrlTrafico,
    formatDateIso,
} from "src/app/shared/utilities/utils";
import { TiposHorasModel } from "src/app/shared/models/horas/tipoHoras.model";
import { AppMensajeModel } from "src/app/shared/models/mensajes/mensajes.model";
import { SubProcesosService } from "./sub-procesos.service";
import { LineaModel } from "src/app/shared/models/regulares/linea.model";
import { AppParam } from "src/app/shared/models/parametros/appparams.model";
import { IdentityTraficoModel } from "src/app/shared/models/login/identityTrafico.model";
import { IdentityTallerModel } from "src/app/shared/models/login/identityTaller.model";
import { LoginUserResponse } from 'src/app/shared/models/login/loginchat.model';
import { concatMap, catchError, tap } from "rxjs/operators";

@Injectable({
    providedIn: "root",
})
export class ServiciosService {
    url: string = `Servicios`;
    paramsSearch: string =
        "fijos=true&regulares=true&discrecionales=true&tad=false&vtc=true";

    private paradasChangedSubject = new Subject<void>();
    private serviciosChangedSubject = new Subject<void>();
    private paradasActivas = new Map<string, number>();
    paradasChanged$ = this.paradasChangedSubject.asObservable();
    serviciosChanged$ = this.serviciosChangedSubject.asObservable();

    constructor(
        private auth: AuthenticationService,
        private http: HttpClient,
        private sPro: SubProcesosService
    ) { }

    // getServiciosLogin(user: string, pass: string, token: string) {
    //   var url = this.formatUrlWithParams(`servicios/getServiciosEmpleado?usuario=${user}&contraseña=${pass}&`);
    //   if (token) {
    //     url = `${url}&token=${token}`;
    //   }
    //   return this.http.get<any[]>(decodeURIComponent(url));
    // }



    loginTrafico(user: string, pass: string): Observable<IdentityTraficoModel> {
        var url = `${this.auth.urlTrafico}login/authenticate`;
        return this.http.post<IdentityTraficoModel>(url, {
            login: user,
            password: pass,
        });
    }
    loginDeviceTaller(): Observable<IdentityTallerModel> {
        console.log("Guardando datos AppT API");
        var deviceId = this.sPro.getDeviceId();
        var url = `${this.auth.urlTaller}login/authenticatedevice?app=1&device=${deviceId}`;
        return this.http.get<IdentityTallerModel>(url);
    }

    getCredencialesVehiculo(codigbus: string, name: string): Observable<LoginUserResponse> {
        var url = `${this.auth.urlTrafico}login/getloggedvehicle?codigbus=${codigbus}&name=${name}`;
        return this.http.get<LoginUserResponse>(url);
    }

    loginDeviceTrafico(): Observable<IdentityTraficoModel> {
        console.log("Guardando datos AppT API");
        var deviceId = this.sPro.getDeviceId();
        var url = `${this.auth.urlTrafico}login/authenticatedevice?app=2&device=${deviceId}`;
        return this.http.get<IdentityTraficoModel>(url);
    }

    updateTokenPush(tokenPush: string): Observable<void> {
        var url = `${this.auth.urlTrafico}login/updatetokenpush`;
        return this.http.post<void>(url, JSON.stringify(tokenPush), { headers: { 'Content-Type': 'application/json' } }
        );
    }

    getServiciosEmpleado(date: Date): Observable<ServicioModel[]> {
        var url = this.formatUrlWithParams(
            `servicios/getServicios?modo=conductor&fecha=${formatDateIso(
                date
            )}&`
        );
        return this.http.get<ServicioModel[]>(decodeURIComponent(url));
    }

    guardarServicio(data: ServicioModel): Observable<void> {
        var url = `${formatUrlTrafico(this.auth, this.url, "postServicio")}`;
        return this.http.post<void>(url, data);
    }

    postLeido(data: ServicioModel): Observable<boolean> {
        var url = `${formatUrlTrafico(this.auth, this.url, "postLeido")}`;
        return this.http.post<boolean>(url, data);
    }

    marcarConformidad(data: ServicioModel): Observable<boolean> {
        var url = `${formatUrlTrafico(
            this.auth,
            this.url,
            "marcarConformidad"
        )}`;
        return this.http.post<boolean>(url, data);
    }

    getParametros(): Observable<AppParam[]> {
        var url = formatUrlTrafico(this.auth, "AppParametros", "getParametros");
        return this.http.get<AppParam[]>(url);
    }

    //Mensajes
    getMensajesConductor(): Observable<AppMensajeModel[]> {
        var url = `${formatUrlTrafico(
            this.auth,
            "Mensaje",
            "getMensajesConductor"
        )}?codemple=${this.auth.currentUserValue.codempleado}`;
        return this.http.get<AppMensajeModel[]>(url);
    }

    //Sanción
    postCodigoSancion(servicio: ServicioModel) {
        var url = `${formatUrlTrafico(
            this.auth,
            this.url,
            "postCodigoSancion"
        )}?Anymonta=${servicio.anymonta}&Nmontaje=${servicio.nmontaje
            }&Numlinea=${servicio.numlinea}&CodSanc=${servicio.codSanc}`;
        return this.http.post<any>(url, servicio);
    }

    //VTC

    iniciarVTC(codservicio: string): Observable<any> {
        var url = `${this.auth.urlVTC}${this.url}/IniciarServicio/${codservicio}`;
        return this.http.get<any>(url);
    }

    finalizarServicio(codservicio: string): Observable<any> {
        var url = `${this.auth.urlVTC}${this.url}/FinalizarServicio/${codservicio}`;
        return this.http.get<any>(url);
    }

    getTiposHoras(): Observable<TiposHorasModel[]> {
        var url = `${this.auth.urlVTC}/TiposHoras/GetTiposHoras`;
        return this.http.get<TiposHorasModel[]>(url);
    }

    getHorasIniciadas(vtcId: string, tipoHoraId: number): Observable<Date> {
        var url = `${this.auth.urlVTC}${this.url}/GetHorasActivas/${vtcId}/${tipoHoraId}`;
        return this.http.get<Date>(url);
    }

    iniciarHorasVTC(inicioEsperaVTC: VtcHorasModel): Observable<any> {
        var url = `${this.auth.urlVTC}/VtcHorasEspera/IniciarHorasEspera`;
        return this.http.post<any>(url, inicioEsperaVTC);
    }

    finalizarHoras(vtcId: string, tipoHoraId: number): Observable<any> {
        var url = `${this.auth.urlVTC}/VtcHorasEspera/FinalizarHorasEspera/${vtcId}/${tipoHoraId}`;
        return this.http.get<any>(url);
    }

    getHorasEspera(vtcId: string): Observable<VtcHorasModel[]> {
        var url = `${this.auth.urlVTC}/VtcHorasEspera/GetHorasEspera/${vtcId}`;
        return this.http.get<VtcHorasModel[]>(url);
    }

    finalizarHorasActivasSiExisten(codservicio: string): Observable<any> {
        return this.getTiposHoras().pipe(
            concatMap((tiposHoras: TiposHorasModel[]) => {
                if (!tiposHoras?.length) {
                    return of([]);
                }

                return forkJoin(
                    tiposHoras.map((tipoHora: TiposHorasModel) =>
                        this.getHorasIniciadas(codservicio, tipoHora.id).pipe(
                            catchError(() => of(null)),
                            concatMap((horaActiva: Date | null) => {
                                if (!horaActiva) {
                                    return of(null);
                                }
                                return this.finalizarHoras(codservicio, tipoHora.id).pipe(
                                    catchError(() => of(null))
                                );
                            })
                        )
                    )
                );
            }),
            tap(() => {
                this.limpiarParadaActiva(codservicio, false);
            })
        );
    }

    //#region Paradas Management


    registrarParadaActiva(codservi: string, tipoHora: TiposHorasModel, notify: boolean = true): void {
        this.paradasActivas.set(codservi, tipoHora.id);
        if (notify) {
            this.notifyParadasChanged();
        }
    }

    limpiarParadaActiva(codservi: string, notify: boolean = true): void {
        this.paradasActivas.delete(codservi);
        if (notify) {
            this.notifyParadasChanged();
        }
    }

    notifyParadasChanged(): void {
        this.paradasChangedSubject.next();
    }

    notifyServiciosChanged(): void {
        this.serviciosChangedSubject.next();
    }

    //#endregion

    //#region Regulares

    getLineasRegu(codserv: string): Observable<LineaModel> {
        var url = decodeURIComponent(
            `${formatUrlTrafico(
                this.auth,
                "Regulares",
                "getRegularLinea?codsregu="
            )}${codserv}`
        );
        return this.http.get<LineaModel>(url);
    }

    getParadasRegbyCodserv(codserv: string): Observable<any> {
        var url = decodeURIComponent(
            `${formatUrlRegulares(
                this.auth.urlRegulares,
                "ParadasReg",
                `getParadasReg?Codservi=${codserv}`
            )}`
        );
        return this.http.get<any>(url);
    }

    getParadasReg(
        Idempresa: number,
        Idlinea: string,
        Tipotrayecto: number
    ): Observable<any> {
        var url = decodeURIComponent(
            `${formatUrlRegulares(
                this.auth.urlRegulares,
                "ParadasReg",
                `getParadasReg?Idempresa=${Idempresa}&Idlinea=${Idlinea}&Codtiphor=1`
            )}`
        );
        return this.http.get<any>(url);
    }

    //#endregion

    sendGeoPos(codserv: string) {
        var geo = this.getGeo();
        var dataParams = `sendGeo?Codservicio=${codserv}&Latitud=${geo.lat}&Longitud=${geo.lng}&Fecha=${this.getNowDate}`;
        var url = decodeURIComponent(
            `${formatUrlTrafico(this.auth, "ApiTrafico", dataParams)}`
        );
        return this.http.get<void>(url);
    }

    get getNowDate() {
        const fecha = new Date();
        const opciones: Intl.DateTimeFormatOptions = {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
        };
        const formato = fecha.toLocaleString(undefined, opciones);
        return formato;
    }

    getGeo() {
        return this.sPro.getGeo();
    }

    formatUrlWithParams(url): string {
        return `${this.auth.urlTrafico}${url}${this.paramsSearch}`;
    }
}
